import { render, staticRenderFns } from "./ReceptionInformationEditor.vue?vue&type=template&id=4c17b95a&scoped=true&"
import script from "./ReceptionInformationEditor.vue?vue&type=script&lang=ts&"
export * from "./ReceptionInformationEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ReceptionInformationEditor.vue?vue&type=style&index=0&id=4c17b95a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c17b95a",
  null
  
)

export default component.exports